import {PHASES_REQUEST, PHASES_SHOW, PHASES_LIST, PHASE_EDIT, PHASES_FAIL} from "./../store/config";

const phaseInit = {
	isFetching: false,
	list: {},
	pages: {
		current: undefined,
		per_page: undefined,
		total: undefined
	},
	edit: {},
	permissions:[],
	error: undefined
};

const phases = (state = phaseInit, action) => {
	switch (action.type) {
		case PHASES_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case PHASES_SHOW:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				pages: action.pages,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case PHASES_LIST:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case PHASE_EDIT:
			return {
				...state,
				isFetching: action.isFetching,
				edit: action.payload,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case PHASES_FAIL:
			return {
				...state,
				isFetching: action.isFetching,
				error: action.error,
				timestamp: action.timestamp
			}
		default:
			return {
				...state
			}
	}
};

export default phases;


// WEBPACK FOOTER //
// ./src/reducers/phases.js